import BaseModule from '$js/base/BaseModule';
import type { FocusTrap } from 'focus-trap';

export class HamburgerService {
  private OPEN_CLASS = 'hamburger-open';
  private TRIGGER = document.querySelector<HTMLElement>('.js-hamburger-trigger');
  private SLIDEOUT = document.querySelector<HTMLElement>('.js-slideout-nav');
  private focusTrapInstance: FocusTrap | null = null;

  constructor() {
    if (!this.TRIGGER || !this.SLIDEOUT) {
      return;
    }

    this.init();
  }

  private isOpen = () => {
    return document.body.classList.contains(this.OPEN_CLASS);
  };

  private init = () => {
    this.SLIDEOUT?.removeAttribute('hidden');

    this.focusTrapInstance = BaseModule.getInstance().focusTrap.initializeFocusTrap([
      '.js-slideout-nav',
    ]);

    this.TRIGGER?.addEventListener('click', this.toggle);

    document.addEventListener('keypress_escape', this.close);
  };

  public toggle = () => {
    if (this.isOpen()) {
      this.close();
      return;
    }

    this.open();
  };

  public open = () => {
    if (this.isOpen()) {
      return;
    }

    document.body.classList.add(this.OPEN_CLASS);
    BaseModule.getInstance().focusTrap.activateFocusTrap(this.focusTrapInstance);
  };

  public close = () => {
    if (!this.isOpen()) {
      return;
    }

    document.body.classList.remove(this.OPEN_CLASS);
    BaseModule.getInstance().focusTrap.deactivateFocusTrap(this.focusTrapInstance);
  };
}
